// extracted by mini-css-extract-plugin
export default {"pill":"Tab_pill__DnPE-"};